import React, { Fragment } from 'react';
import { Button } from 'primereact/button';
import { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { useEffect } from 'react';
import { certificateService } from '../../../../services/profile';
import { confirmDialog } from 'primereact/confirmdialog';
import CertificationForm from './certificate_form';
import { Util } from '../../../../services';
import { Carousel } from 'primereact/carousel';
import properties from '../../../../config/environmentProperties';

function ProfileCertification({ userCertifications, onRefresh }) {
    const [certificateData, setCertificateData] = useState([]);
    const [showNewForm, setShowNewForm] = useState(false);
    const [editData, setEditData] = useState({});
    const [visible, setVisible] = useState(false);
    const docPath = properties.currentEnvironment.docPath + 'expense-documnets/';
    const [currentRowData, setCurrentRowData] = useState(null);
    useEffect(() => {
        setCertificateData(userCertifications);
    }, [userCertifications]);

    const clearForm = () => {
        setEditData({});
    };

    const createForm = () => {
        setEditData({});
        setShowNewForm(true);
    };

    const editForm = (rowData) => {
        setEditData(rowData);
        setShowNewForm(true);
    };

    const add_certificate = (data) => {
        certificateService.addCertificate(data).then((resp) => {
            onRefresh();
            setShowNewForm(false);
        });
    };

    const update_certificate = (data) => {
        data = { ...data, id: editData.id };
        certificateService.updateCertificate(data).then((resp) => {
            onRefresh();
            setShowNewForm(false);
        });
    };

    const delete_certificate = (e, row) => {
        confirmDialog({
            target: e.currentTarget,
            message: 'Are you sure you want to delete?',
            header: 'Delete Confirmation',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'No',
            rejectLabel: 'Yes',
            reject: () => {
                certificateService.deleteCertificate(row.id).then(resp => { onRefresh(); }, (error) => {

                })
            },
            accept: () => { }
        })
    }

    const CertificateDialog = () => {
        return (
            <div className="flex align-items-center flex-column px-3">
                <Dialog header={editData.id ? "Update Certification" : "Add Certification"} visible={showNewForm} style={{ width: '500px' }} onHide={() => setShowNewForm(false)}>
                    <CertificationForm
                        editData={editData}
                        closeForm={() => setShowNewForm(false)}
                        addCertificate={(data) => add_certificate(data)}
                        updateCertificate={(data) => update_certificate(data)}
                        clearForm={clearForm}
                    />
                </Dialog>
            </div>
        )
    }
    const caraouselPopup = () => {
        return (
            <Dialog header={'Documents'} visible={visible} style={{ width: '1200px', height: '900px' }} onHide={() => setVisible(false)}>
                {renderCarouselContent(currentRowData)}
            </Dialog>
        )
    }
    const renderCarouselContent = (rowData) => {
        return (
            <Carousel
                value={[rowData?.docs]}
                itemTemplate={yourCarouselItemTemplate}
                numVisible={1}
                numScroll={1}
                circular
            />
        );
    };
    const yourCarouselItemTemplate = (doc) => {
        return (
            <>
                <p>{doc.fileName}</p>
                <iframe src={docPath + doc.fileName} title={`Document ${doc.fileName}`} style={{ width: '100%', height: '900px' }} />
            </>
        )
    };
    return (
        <Fragment>
            {caraouselPopup()}
            {certificateData && (
                <>
                    {CertificateDialog()}
                    <div className='wrapper p-3'>
                        <div className='grid'>
                            <div className='col'>
                                <span className='heading'>
                                    Certifications
                                    <div className='heading-actions'>
                                        <Button label="Add" disabled className="p-button-text" />
                                        <Button icon="pi pi-plus" onClick={() => createForm()}
                                            className="p-button-rounded p-button circle" aria-label="Add" />
                                    </div>
                                </span>
                            </div>
                        </div>

                        {certificateData.map(item =>
                            <div className='project-wrapper'>
                                <div style={{ float: 'right' }}>
                                  {item.documentId && ( 
                                        <Button icon="pi pi-eye" className="p-button-rounded p-button-secondary ml-2" style={{ border: 'none', borderRadius: '50%' }} onClick={() => { setCurrentRowData(item); setVisible(true) }} aria-label="Edit" />
                                   )}
                                    <Button icon="pi pi-pencil" className="p-button-rounded p-button-secondary ml-2" style={{ border: 'none', borderRadius: '50%'}} onClick={() => editForm(item)}  aria-label="Edit" />
                                    <Button icon="pi pi-trash" className="p-button-rounded p-button-danger ml-2" style={{ border: 'none', borderRadius: '50%' }} onClick={(e) => delete_certificate(e, item)} aria-label="Delete" />
                                </div>
                                <div className='profile-body'>{item.title}</div>
                                <div className='mb-2 mt-2' style={{ color: 'black' }}>{item.issuingOrganization}</div>
                                <div>Issued {item.issueDate ? Util.dateConverterUS(item.issueDate) : 'N/A'}</div>
                                <div className='mt-2'>
                                    <a href={'http://' + item.credentialUrl}>{item.credentialUrl}</a>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}
        </Fragment>
    );
}

export default ProfileCertification;